const BOOK_SHOW_PAGE_TEMPLATE = `
    <section id="book-details"></section>
    <div class="container">
        <h3 class="book-title"><%= app.localeManager.get("book.similar") %></h3>
    </div>
    <section id="books-banner"></section>
`;

const BookShowPage = Backbone.View.extend({
    
    id: "books-show-page",

    components: {
        bookDetails: {},
        bookSuggestion: {}
    },

    template: _.template(BOOK_SHOW_PAGE_TEMPLATE),

    initialize: function() {
        var books = [], themes;

        // Get 8 books related to the selected book (we select them by the themes)
        // We use map to return an array of strings instead of objects
        // The filterBy method won't work with objects
        if (this.model.get("theme")) {
            themes = this.model.get("theme").map(function(el) { return el.name });
            books = window.BOOKCOLLECTION.filterBy("theme", themes).slice(0, 8);
        }
        this.collection = new BookCollection(books);
        this.components.bookDetails = new BookDetailsComponent({ model: this.model });
        this.components.bookSuggestion = new BooksBannerComponent({ collection: this.collection });
    },

    afterRender: function() {
        this.components.bookSuggestion.afterRender();
        this.components.bookDetails.afterRender();
    },

    render: function() {
        this.$el.html(this.template());
        this.$el.find("#book-details").html(this.components.bookDetails.render().el);
        this.$el.find("#books-banner").html(this.components.bookSuggestion.render().el);

        return this;
    },

});
